import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Globe, MapPin, Facebook, Linkedin, Twitter, Instagram } from 'lucide-react';
import { companyDivisions, contactInfo, socialLinks } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="text-3xl font-bold mb-4">
              <span className="text-white">EAGLES</span>
              <span className="text-[#D4AF37]">WAY</span>
              <span className="text-white"> GROUP</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              A leading international business group providing global trading, procurement, logistics, and marketing services across UAE, UK, and USA.
            </p>
            
            {/* Social Links */}
            <div className="flex space-x-4 mb-6">
              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-900 hover:bg-[#D4AF37] rounded-full flex items-center justify-center transition-all duration-300"
                aria-label="Facebook"
              >
                <Facebook size={18} className="text-gray-400 hover:text-black" />
              </a>
              <a
                href={socialLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-900 hover:bg-[#D4AF37] rounded-full flex items-center justify-center transition-all duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} className="text-gray-400 hover:text-black" />
              </a>
              <a
                href={socialLinks.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-900 hover:bg-[#D4AF37] rounded-full flex items-center justify-center transition-all duration-300"
                aria-label="Twitter"
              >
                <Twitter size={18} className="text-gray-400 hover:text-black" />
              </a>
              <a
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-900 hover:bg-[#D4AF37] rounded-full flex items-center justify-center transition-all duration-300"
                aria-label="Instagram"
              >
                <Instagram size={18} className="text-gray-400 hover:text-black" />
              </a>
            </div>

            {/* Main Contact */}
            <div className="space-y-2">
              <a
                href={`tel:${contactInfo.phone}`}
                className="flex items-center text-gray-400 hover:text-[#D4AF37] transition-colors text-sm"
              >
                <Phone size={14} className="mr-2" />
                {contactInfo.phone}
              </a>
              <a
                href={`mailto:${contactInfo.email}`}
                className="flex items-center text-gray-400 hover:text-[#D4AF37] transition-colors text-sm"
              >
                <Mail size={14} className="mr-2" />
                {contactInfo.email}
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/companies" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Our Companies
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/global-presence" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Global Presence
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Our Divisions */}
          <div className="lg:col-span-2">
            <h3 className="text-white font-semibold mb-4 text-lg">Our Global Divisions</h3>
            <div className="space-y-4">
              {companyDivisions.map((division) => (
                <div key={division.id} className="border-l-2 border-[#D4AF37] pl-4">
                  <h4 className="text-white font-medium text-sm mb-1">
                    {division.company}
                  </h4>
                  <p className="text-gray-500 text-xs mb-1">{division.location}</p>
                  <a
                    href={`tel:${division.phone}`}
                    className="text-gray-400 hover:text-[#D4AF37] transition-colors text-xs"
                  >
                    {division.phone}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm mb-4 md:mb-0">
              © 2023 Eaglesway Group. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/contact" className="text-gray-500 hover:text-[#D4AF37] transition-colors">
                Privacy Policy
              </Link>
              <Link to="/contact" className="text-gray-500 hover:text-[#D4AF37] transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
